import { borderRadiusSm, COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.WHITE};
  padding: 10rem 15rem;
  border-radius: ${borderRadiusSm};
  z-index: 2;
  border: 1rem solid ${COLORS.GREEN};
  width: 250rem;
  margin-top: 55rem;
  transform: translate(-50%);
  top: 0;

  ${respondTo.smallPhone`
    width: 100%;  
    min-width: auto;
    transform: none;
    right: 0;
    margin-top: 75rem;
  `}
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10rem 0;
  color: ${COLORS.BLACK};
  text-align: center;
  width: 100%;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    color: ${COLORS.GREEN};
  }

  &:first-of-type {
    border-bottom: 1rem solid ${COLORS.BORDER};
  }
`;
